import { getJson } from './http';

export async function listImageHistory({ tenant, limit = 100, offset = 0 }) {
  const q = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  // No headers; pass tenant in the URL like the rest of your API
  return getJson(`/api/history/${tenant}/images?${q.toString()}`);
}
